import React, { Component } from 'react';
import Input from '../../components/Input';
import Select from 'react-select';
import { FaTimes } from 'react-icons/fa';
import { observer } from 'mobx-react';
import userStore from '../../stores/userStore';
import generalStore from '../../stores/generalStore';

const UpdateUserModal = observer(class UpdateUserModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            employeeName: '',
            email: '',
            designation: null,
            image: null,
        };
    }

    componentDidMount() {
        const currentUser = userStore.currentUser;

        this.setState({
            employeeName: currentUser.employeeName,
            email: currentUser.email,
            designation: { value: currentUser.designation, label: currentUser.designation },
        });

        document.addEventListener('keydown', this.handleKeyDown);
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyDown);
    }

    handleKeyDown = (event) => {
        if (event.key === 'Escape') {
            userStore.setUpdateUserModalVisible(false);
            userStore.setCurrentUser(null);
        }
    };

    handleDesignationSelect = (data) => {
        this.setState({ designation: data });
    };

    handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const img = new Image();
            img.src = URL.createObjectURL(file);
            img.onload = () => {
                if (img.width >= 400 && img.height >= 400) {
                    if (file.size <= 2 * 1024 * 1024) {
                        const fileExtension = file.name.split('.').pop();

                        const newFile = new File([file], `${file.lastModified}-${Math.floor(Math.random() * 99999)}.${fileExtension}`, {
                            type: file.type,
                            lastModified: file.lastModified,
                        });
                        this.setState({ image: newFile });
                    } else {
                        alert('File size cannot exceed 2MB.');
                    }
                } else {
                    alert('Image dimensions must be at least 400x400 pixels.');
                }
            };
        }
    };

    handleSave = async () => {
        const { image, employeeName, email, designation } = this.state;
        const { profileImagePath } = userStore.currentUser;

        const isImageUpdated = image && image !== profileImagePath;

        const updatedUserData = {
            employeeName,
            email,
            designation: designation ? designation.value : null,
            profileImagePath: isImageUpdated ? image : profileImagePath,
            empId: userStore.currentUser.empId,
        };

        try {
            await userStore.updateUser(updatedUserData);

            const updatedUsers = userStore.users.map(user =>
                user.empId === updatedUserData.empId ? { ...user, ...updatedUserData } : user
            );

            userStore.setUsers(updatedUsers);
            userStore.setUpdateUserModalVisible(false);
            userStore.setCurrentUser(null);
        } catch (error) {
            console.error('Error updating profile:', error);
        }
    };

    validateFields = () => {
        const { employeeName, email, designation } = this.state;
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        return (
            employeeName.trim() !== '' &&
            emailPattern.test(email) &&
            designation !== null
        );
    };

    render() {
        const { employeeName, email, designation, } = this.state;

        const designationOptions = [
            { value: 'Admin', label: 'Admin' },
            { value: 'Contributor', label: 'Contributor' },
            { value: 'Intern', label: 'Intern' },
        ];

        return (
            <div className="fixed inset-0 flex flex-col items-center justify-center bg-black bg-opacity-50">
                <div className="flex relative flex-col overflow-scroll w-full lg:w-1/2 h-full lg:h-[90%]  py-6 px-5 lg:px-10 overflow-y-scroll overflow-x-hidden bg-white shadow-lg">

                    <div className='flex flex-col z-10'>
                        <div className='flex flex-1 justify-center'>
                            {
                                userStore.currentUser.profileImagePath ? <img src={process.env.REACT_APP_BASE_URL + "/" + userStore.currentUser.profileImagePath} className='w-[120px] h-[120px] rounded-full' alt='Profile' /> :
                                    <div className='w-[120px] h-[120px] rounded-full bg-gray-200 flex justify-center items-center text-2xl text-black/50 select-none'>{generalStore.getInitials(employeeName)}</div>
                            }
                        </div>

                        <div className='h-[1px] w-full bg-[#DDE1E6] mt-6'></div>
                        <span className='font-normal text-lg text-[#21272A] my-6'>User Details</span>

                        <div className='flex flex-col lg:flex-row gap-4 mt-4'>
                            <Input
                                title="User Name"
                                onChange={(e) => this.setState({ employeeName: e.target.value })}
                                value={employeeName}
                            />
                        </div>

                        <div className='flex flex-col lg:flex-row gap-4 mt-4'>
                            <Input
                                type="email"
                                title="E-mail"
                                onChange={(e) => this.setState({ email: e.target.value })}
                                value={email}
                            />
                            <div className='flex flex-1 flex-col justify-center'>
                                <span className='text-sm font-normal text-[#21272A] my-2'>Designation</span>
                                <Select
                                    options={designationOptions}
                                    placeholder="Select..."
                                    value={designation}
                                    onChange={this.handleDesignationSelect}
                                    isSearchable={true}
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            backgroundColor: '#F0EFEF',
                                            paddingTop: 5,
                                            paddingBottom: 5,
                                            boxShadow: 'none',
                                            border: '1px solid #ccc',
                                            '&:hover': {
                                                border: '1px solid #ccc',
                                            },
                                        }),
                                        indicatorsContainer: (provided) => ({
                                            ...provided,
                                            display: 'none',
                                        }),
                                    }}
                                />
                            </div>
                        </div>

                        <div className="mt-14 flex justify-end gap-2">
                            <button
                                disabled={!this.validateFields()}
                                className={`text-white font-medium text-base px-6 py-2 rounded-md ${this.validateFields() ? 'bg-[#130D0D]' : 'bg-gray-400'}`}
                                onClick={this.handleSave}
                            >
                                Update
                            </button>

                            <button onClick={() => {
                                userStore.setUpdateUserModalVisible(false);
                                userStore.setCurrentUser(null);
                            }} className='absolute right-5 top-4'>
                                <FaTimes size={20} color='black'></FaTimes>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
});

export default UpdateUserModal;
